module.exports = "<div> <group title=Default> <m-textarea :max=200 placeholder=\"I'm placeholder\"></m-textarea> </group> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/MTextarea.vue
 ** module id = 193
 ** module chunks = 0
 **/